import React, { useEffect, useState } from "react";
import DashboardTable from "../../components/DashboardTable/DashboardTable";
import TenderFilterBar from "../../components/TenderFilterBar/TenderFilterBar";
import { TenderControllerContainer } from "./TenderListingController.styles";
import { fetchTenders, deleteTender, getEmployers, getBrokers } from "../../api/api";
import { useToast } from "../../components/ToastProvider/ToastProvider";

export default function TenderListingController() {
    const [tableData, setTableData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [employers, setEmployers] = useState([]);
    const [brokers, setBrokers] = useState([]);

    const [filters, setFilters] = useState({
        isMyTenders: true,
        selectedStatus: "Active",
        searchText: "",
        sortOrder: "asc",
        sortColumn: "employer_name",
        filteredBroker: null,
        filteredEmployer: null
    });

    const { showToast } = useToast();

    const getTenders = async (newFilters = filters, newPage = page) => {
        const payload = { ...newFilters, page: newPage };

        try {
            const response = await fetchTenders(payload);
            setTableData(response.payload.tenders || []);
            setTotalPages(response.payload.total_pages || 1);
        } catch (error) {
            console.error("Failed to fetch tenders:", error);
        }
    };

    const fetchBrokers = async() => {
        try {
            const response = await getBrokers();
            setBrokers(response);
        } catch (error) {
            console.error("Failed to fetch broker information:", error);
        }
    }

    const fetchEmployers = async() => {
        try {
            const response = await getEmployers();
            setEmployers(response);
        } catch (error) {
            console.error("Failed to fetch broker information:", error);
        }
    }

    useEffect(() => {
        getTenders(filters, page);
        fetchEmployers();
        fetchBrokers();
    }, []);

    const handlePageChange = (newPage) => {
        setPage(newPage);
        getTenders(filters, newPage);
    };

    const handleFilterChange = (newPartialFilters) => {
        const updatedFilters = { ...filters, ...newPartialFilters };
        setFilters(updatedFilters);
        setPage(1);
        getTenders(updatedFilters, 1);
    };

    const handleSort = (column) => {
        const isAsc = filters.sortColumn === column && filters.sortOrder === "asc";
        const newOrder = isAsc ? "desc" : "asc";

        handleFilterChange({
            sortColumn: column,
            sortOrder: newOrder,
        });
    };
    const handleDelete = async (tenderId) => {
        try {
            await deleteTender(tenderId);
            setTableData((prev) => prev.filter((t) => t.tender_id !== tenderId));
            showToast("Tender deleted successfully", "success");
        } catch (e) {
            if (e.isAuthExpired) return;
            showToast("Failed to delete tender", "error");
        }
    }

    return (
        <TenderControllerContainer>
        <TenderFilterBar 
            hidden={false} 
            getTenders={handleFilterChange} 
            employers={employers}
            brokers={brokers}
        />
        <DashboardTable
            tenders={tableData}
            page={page}
            onPageChange={(_event, newPage) => handlePageChange(newPage)}
            totalPages={totalPages}
            onSort={handleSort}
            onDelete={handleDelete}
            sortOrder={filters.sortOrder}
            sortColumn={filters.sortColumn}
        />
        </TenderControllerContainer>
    );
}